import React from 'react'
import { Dropdown } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl';

export default function CustomerGroupsTableTopBar(props) {
    const [storeUrl] = useStoreUrl()
    return (
        <div className="inner d-flex">
            <div className="lt">
                <Link
                    to={storeUrl + "/customers/group/create"}
                    className="st-btn st-btn-primary no-min-width st-btn-sm d-flex align-items-center justify-content-center btn btn-primary">
                    <FeatherIcon
                        icon="plus"
                        size="14"
                        className="icon me-2" />
                    <span>Create Customer Group</span>
                </Link>
            </div>

            <div className="rt ms-auto d-flex">
                <div className="rt_item st-form form-sm st-form-with-icon-left search mb-0 me-2">
                    <input type="text" className="form-control" placeholder="Search" onChange={props.handleSearchChange} />
                    <div className="icon">
                        <FeatherIcon
                            icon="search"
                            size="15"
                            className="icon-main" />
                    </div>
                </div>
                <div className="rt_item button-container export-options me-2">
                    <Dropdown className="st-bs-dropdown no-down-icon">
                        <Dropdown.Toggle className="st-btn st-btn-primary no-min-width st-btn-sm d-flex align-items-center justify-content-center btn btn-primary">
                            <FeatherIcon
                                icon="edit"
                                size="14"
                                className="icon me-2" />
                            <span>Edit Columns</span>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <label className="dropdown-item st-checkbox d-inline-flex cursor-pointer">
                                <input
                                    type="checkbox"
                                    className="d-none"
                                    defaultChecked={props.column__GroupName}
                                    onChange={ev => {
                                        (ev.target.checked) ? props.setColumn__GroupName(true) : props.setColumn__GroupName(false)
                                    }} />
                                <span className="box d-flex align-items-center justify-content-center border">
                                    <FeatherIcon
                                        icon="check"
                                        size="15"
                                        className="icon position-relative" />
                                </span>
                                <span className="text ms-2">Group Name</span>
                            </label>

                            <label className="dropdown-item st-checkbox d-inline-flex cursor-pointer">
                                <input
                                    type="checkbox"
                                    className="d-none"
                                    defaultChecked={props.column__DiscountPercent}
                                    onChange={ev => {
                                        (ev.target.checked) ? props.setColumn__DiscountPercent(true) : props.setColumn__DiscountPercent(false)
                                    }} />
                                <span className="box d-flex align-items-center justify-content-center border">
                                    <FeatherIcon
                                        icon="check"
                                        size="15"
                                        className="icon position-relative" />
                                </span>
                                <span className="text ms-2">Discount Percent</span>
                            </label>

                            <label className="dropdown-item st-checkbox d-inline-flex cursor-pointer">
                                <input
                                    type="checkbox"
                                    className="d-none"
                                    defaultChecked={props.column__DiscountValue}
                                    onChange={ev => {
                                        (ev.target.checked) ? props.setColumn__DiscountValue(true) : props.setColumn__DiscountValue(false)
                                    }} />
                                <span className="box d-flex align-items-center justify-content-center border">
                                    <FeatherIcon
                                        icon="check"
                                        size="15"
                                        className="icon position-relative" />
                                </span>
                                <span className="text ms-2">Discount Value</span>
                            </label>

                            <label className="dropdown-item st-checkbox d-inline-flex cursor-pointer">
                                <input
                                    type="checkbox"
                                    className="d-none"
                                    defaultChecked={props.column__Status}
                                    onChange={ev => {
                                        (ev.target.checked) ? props.setColumn__Status(true) : props.setColumn__Status(false)
                                    }} />
                                <span className="box d-flex align-items-center justify-content-center border">
                                    <FeatherIcon
                                        icon="check"
                                        size="15"
                                        className="icon position-relative" />
                                </span>
                                <span className="text ms-2">Status</span>
                            </label>


                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                <div className="rt_item button-container export-options me-2">
                    <Dropdown className="st-bs-dropdown no-down-icon">
                        <Dropdown.Toggle className="st-btn st-btn-primary no-min-width st-btn-sm d-flex align-items-center justify-content-center btn btn-primary">
                            <FeatherIcon
                                icon="download"
                                size="14"
                                className="icon me-2" />
                            <span>Export</span>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item href="#/action-1" className="d-flex align-items-center">
                                <FeatherIcon
                                    icon="file"
                                    size="13"
                                    className="icon me-2" />
                                <span>Excel</span>
                            </Dropdown.Item>
                            <Dropdown.Item href="#/action-2" className="d-flex align-items-center">
                                <FeatherIcon
                                    icon="file"
                                    size="13"
                                    className="icon me-2" />
                                <span>PDF</span>
                            </Dropdown.Item>
                            <Dropdown.Item href="#/action-3" className="d-flex align-items-center">
                                <FeatherIcon
                                    icon="printer"
                                    size="13"
                                    className="icon me-2" />
                                <span>Print</span>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                <div className="rt_item button-container more-options">
                    <Dropdown className="st-bs-dropdown no-down-icon">
                        <Dropdown.Toggle className="st-round-btn st-btn-rounded-square-btn st-btn-primary st-btn-sm d-flex align-items-center justify-content-center">
                            <FeatherIcon
                                icon="more-horizontal"
                                size="55"
                                className="icon" />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item href="#/action-1" className="d-flex align-items-center">
                                <FeatherIcon
                                    icon="trash"
                                    size="13"
                                    className="icon me-2" />
                                <span>Bulk Delete</span>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
        </div>
    )
}
